// mui 5
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const StyledContentWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 2),
}));

export const StyledRecommendation = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(8),
}));
